/**
 * Transforms Confluence URLs to include page view attribution.
 */
export const transformIfConfluenceLink = (
	url: string,
	shouldAddAttribution: boolean = false,
): string => {
	if (!url.includes('/wiki/spaces/') || !shouldAddAttribution) {
		return url;
	}

	try {
		const urlObj = new URL(url);
		urlObj.searchParams.set('atl_f', 'ROVOCHAT');
		return urlObj.toString();
	} catch {
		// Fallback to original URL if URL parsing fails
		return url;
	}
};
